// Erkennt zuverlässig, ob der Code gerade im react-snap-Puppeteer-
// Kontext läuft (User-Agent wird von react-snap fest auf "ReactSnap"
// gesetzt) statt in einem echten Nutzer-Browser.
export const isPrerender =
  typeof navigator !== "undefined" &&
  /ReactSnap/i.test(navigator.userAgent);